import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from '../hooks';
import { selectEntityState } from '../reducers/entityStatesSlice';
import { EntityHumidity } from './EntityHumidity';
import { EntityTemperature } from './EntityTemperature';
export const Sensor = props => {
    const tempState = useAppSelector(selectEntityState(props.temp.id));
    const d = new Date(tempState ? tempState.ts : 0);
    const age = (Date.now() - d.getTime()) / 1000.0;
    let time;
    if (age > 30 * 60) { // 30 minutes
        const year = d.getFullYear();
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        const hour = ('0' + d.getHours()).slice(-2);
        const minute = ('0' + d.getMinutes()).slice(-2);
        const second = ('0' + d.getSeconds()).slice(-2);
        const str = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        time = (_jsxs("span", { style: { 'fontSize': '80%', 'paddingLeft': '10px' }, children: ["(", str, ")"] }));
    }
    else {
        time = '';
    }
    const humid = props.humid ? _jsx(EntityHumidity, { entity: props.humid }) : null;
    return (_jsx("div", { className: "sensor", children: _jsxs("div", { children: [_jsx("div", { style: { 'float': 'right', 'fontSize': '200%' }, children: _jsx(EntityTemperature, { entity: props.temp }) }), _jsxs("div", { children: [props.device.title, time] }), _jsx("div", { children: humid })] }) }));
};
